function waitForElement(selector, callback, interval = 100, timeout = 10000) {
  const startTime = Date.now();

  const checkExist = setInterval(() => {
    const element = document.querySelector(selector);

    if (element) {
      clearInterval(checkExist);
      callback(element);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(checkExist);
      console.warn(`Element "${selector}" not found within timeout.`);
    }
  }, interval);
}

waitForElement(".product--div .diamond__content--price", (buttonWrapper) => {
  console.log(buttonWrapper)
  const chooseButton = buttonWrapper.querySelector(".chooseDiamond");

  if (!chooseButton) {
    console.warn("No .chooseDiamond button found inside .diamond__content--price");
    return;
  }

  chooseButton.addEventListener("click", (e) => {
    e.preventDefault();

    const chooseDiamondContainer = document.querySelector("#choose-diamond .modal-content");

    if (!chooseDiamondContainer) {
      console.warn("#choose-diamond container not found");
      return;
    }

    chooseDiamondContainer.style.display = "none";

    const addDiamondButton = chooseDiamondContainer.querySelector(".add_diamond, #add_diamond"); // подстраховка на оба селектора

    if (addDiamondButton) {
      addDiamondButton.click();
    } else {
      console.warn(".add_diamond button not found inside #choose-diamond");
    }
  });
});